import React, { useState } from "react";
import moment from 'moment';

import { Popover } from '@mui/material';

export default ({rst, rstData, account, itemTitle, classes, itemPredicateId, getRstMetaData}) => {
  const [opened, setOpened] = useState(false);
  const [trplsMetaData,  setTrplsMetaData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event, rstData) => {
    const { trplArray } = rstData;

    if (trplArray.length) {
      const trplsIds = trplArray.map(trpl => trpl.tid);

      getRstMetaData(trplsIds, (res) => {
        setTrplsMetaData(res.trpls_meta_data);
      });
    }
    
    setAnchorEl(event.currentTarget);
  };

  const openRst = (ancestor, rstId) => {
    window.open(`/rst_edit?id=${ancestor}&pid=${rstId}`, '_blank', 'noreferrer noopener');
  };

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        className={classes.popover}
        onClose={() => {
          setOpened(false);
          setAnchorEl(null);
          setTrplsMetaData(null);
        }}
        disableRestoreFocus
      >
        <div className={classes.rstInfoPopover}>
          <span>
            {rstData && rstData.concepts && rstData.concepts.length === itemPredicateId.length && account.access_level > 1
              ? itemPredicateId.map((pid, index) => {
              return (
                <a key={`${rstData.concepts[index]}.${pid}`} id={pid} className={classes.link} onClick={() => openRst(rstData.concepts[index], pid)}>
                  {pid}{itemPredicateId.length - 1 !== index ? '.' : ''}
                </a>
              )
            }) : Array.isArray(rst.id) ? rst.id.join('.') : rst.id}
              
            {' '}{rst.type}{' '}
            {rstData && rstData.nodeTitle && rst.type === 'OBJECT' ? (
              <a className={classes.rstConceptLink} href={`/node/${rst.oid}`}>
                {rstData.nodeTitle}
              </a>
            ) : null}
          </span>

          {rst.overridden_by ? (
            <div>Overridden by: {rst.overridden_by}</div>
          ) : rst.inverted ? (
            <div>Inverted</div>
          ) : rst.isTitle ? (
            <div>Title</div>
          ) : null}

          {trplsMetaData && Object.keys(trplsMetaData).length ? (
            <div style={{ marginTop: '3px' }}>
              {Object.values(trplsMetaData).map((trplsData, index) => (
                <div key={index} style={{ marginTop: '2px' }}>
                  <span>{Object.keys(trplsMetaData)[index]} {moment(trplsData.upd_time).format('DD/MM/YYYY HH:mm')}</span>
                  <div style={{ marginTop: '2px' }}>
                    <span>creator: {trplsData.creator} / {trplsData.creator_iid}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </Popover>

      <div
        aria-haspopup="true"
        onClick={(e) => {
          if (rstData) setOpened(true);
          if (rstData) handlePopoverOpen(e, rstData);
        }}
        className={classes.rstInfoContainer}
        aria-owns={opened ? 'mouse-over-popover' : undefined}
      >
        <span
          className={`${classes.rstInfoTitle} ${classes.alignCenter} ${rstData ? classes.pointer : ''}`}
          style={{
            fontStyle: `${rst.overridden_by || rst.inverted ? 'italic' : ''}`,
            fontWeight: `${rst.isTitle ? '550' : ''}`,
            height: '24px',
          }}
        >
          {itemTitle}
        </span>
      </div>
    </React.Fragment>
  )
};
